import { api } from "..";
import {
  ColumnSort,
  UserTablePreferences,
} from "@/types/ApiResponses/UserTablePreferences";

export interface UpdateTablePreferencesPayload {
  hiddenColumns?: string[];
  pageSize?: number | null;
  columnOrder?: string[] | null;
  columnSizing?: Record<string, number> | null;
  columnSorting?: ColumnSort[] | null;
}

export const updateTablePreferences = async (
  tableKey: string,
  payload: UpdateTablePreferencesPayload
): Promise<UserTablePreferences> => {
  const res = await api.client.patch(`/table-preferences/${tableKey}`, payload);
  return res.data;
};
